import { Input, Component, OnInit } from '@angular/core';

@Component({
  selector: 'score-circle',
  templateUrl: './score-circle.component.html'
})
export class ScoreCircleComponent implements OnInit {
    public maxScore: number = 69.115038379;
    @Input() score: number = null;
    @Input() dashOffset: number = null;
    @Input() precision: number = 0;
    @Input() size: string = 'small';

    public width: number = 28;
    public height: number = 28;
    public r: number = 11;
    public cx: number = 14;
    public cy: number = 14;

    constructor() { }

    ngOnInit() {
        if(this.size == '34')
        {
            this.maxScore = 81.6814;
            this.width = 34;
            this.height = 34;
            this.r = 13;
            this.cx = this.cy = 17;
        }

        this.score = this.score || 0;
    }

    getDashOffset(correction: number = 0): number {
        let ret = 0;
        if(this.dashOffset)
        {
            if(this.dashOffset >= this.maxScore)
            {
                this.dashOffset = this.maxScore - 1;
            }
            ret = (this.dashOffset-this.maxScore) + correction;
        }
        else
        {
            ret = this.maxScore-(this.maxScore * (this.score/10)+correction)
        }

        if(ret > this.maxScore-1)
        {
            ret = this.maxScore -1;
        }

        return ret
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/score-circle/score-circle.component.ts